import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useAddNote, useCloseConversation, useSendMessage } from '~/hooks/useConversations';

export default function useActionBar({ conversationId, onStatusChange }) {
  const [activeAction, setActiveAction] = useState(null);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const queryClient = useQueryClient();

  const sendMessageMutation = useSendMessage(conversationId, queryClient, (data) => {
    if (!data.status.startsWith('closed')) {
      onStatusChange?.(data.status);
    }
  });
  const addNoteMutation = useAddNote(conversationId, queryClient);
  const closeConversationMutation = useCloseConversation(conversationId, queryClient, (data) => {
    onStatusChange?.(data.status);
  });

  const toggleAction = (action) => setActiveAction((prev) => (prev === action ? null : action));

  const handleCloseConversation = () => {
    setShowCloseModal(false);
    closeConversationMutation.mutate(undefined, {
      onSuccess: () => {
        setActiveAction(null);
      },
    });
  };

  return {
    activeAction,
    toggleAction,
    showCloseModal,
    setShowCloseModal,
    sendMessageMutation,
    addNoteMutation,
    closeConversationMutation,
    handleCloseConversation,
  };
}
